import { type PropsWithChildren } from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

type IPresetContainerProps = PropsWithChildren<{
  className?: string
}>

export const PresetContainer = ({ children, className }: IPresetContainerProps) => (
  <div className={classNames(styles.container, className)}>{children}</div>
)
